// streamSettings.js

const state = {
    streamSettings: {}, // Holds the streaming settings
    pollingIntervalId: null, // Stores interval ID
    pollingIntervalTime: 5000, // 5 seconds polling
}

const mutations = {
    SET_STREAM_SETTINGS(state, payload) {
        state.streamSettings = payload
    },
    SET_POLLING_INTERVAL_ID(state, intervalId) {
        state.pollingIntervalId = intervalId
    },
}

const actions = {
    async fetchStreamSettings({ commit }) {
        if (!window.base_domain || !window.Church || !window.Church.slug) {
            return
        }

        try {
            const response = await fetch(`//api.${window.base_domain}/${window.Church.slug}/streaming-settings`)
            if (response.status === 200) {
                const finalRes = await response.json()
                commit('SET_STREAM_SETTINGS', finalRes.data)
            } else {
                console.error('Failed to fetch stream settings, status: ' + response.status)
            }
        } catch (error) {
            // Network errors (CORS, DNS, connectivity) are expected in some embed contexts
            console.error('Error fetching stream settings:', error.message)
        }
    },
    startPolling({ dispatch, state, commit }) {
        dispatch('fetchStreamSettings')

        if (state.pollingIntervalId) {
            clearInterval(state.pollingIntervalId)
        }

        const intervalId = setInterval(() => {
            dispatch('fetchStreamSettings')
        }, state.pollingIntervalTime)

        commit('SET_POLLING_INTERVAL_ID', intervalId)
    },
    stopPolling({ state, commit }) {
        if (state.pollingIntervalId) {
            clearInterval(state.pollingIntervalId)
            commit('SET_POLLING_INTERVAL_ID', null)
        }
    },
}

const getters = {
    streamSettings(state) {
        return state.streamSettings
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
